import logger from "../utils/logger";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../slices/userReducer";
import Cookies from "js-cookie";
import { supabase } from "../supabaseClient";
import InviteSuccessModal from "../components/InviteSuccessModal";

const ProcessInvite = () => {
  const user = useSelector(selectUser);
  const [inviteResult, setInviteResult] = useState(null);
  const [showInviteModal, setShowInviteModal] = useState(false);

  useEffect(() => {
    const processInvite = async () => {
      // Check if user is logged in and there's an invite code
      if (user?.id) {
        const inviteCode = Cookies.get("spinWinInvite");

        if (inviteCode) {
          try {
            // Call an edge function to process the invite
            const { data, error } = await supabase.functions.invoke(
              "processInvite",
              {
                body: JSON.stringify({
                  inviteCode,
                  userId: user.id,
                }),
              }
            );


            if (error) {
              logger.error("❌ [ProcessInvite] Error processing invite:", error);
              return;
            }

            if (data.success) {

              // If payment required for this prize, go straight to checkout
              if (data.payment_required && data.participant_id) {
                Cookies.remove("spinWinInvite");
                window.location.replace(`/checkout?spinParticipant=${data.participant_id}`);
                return;
              }

              // Otherwise, show success modal for free +1
              setInviteResult(data);
              setShowInviteModal(true);
              Cookies.remove("spinWinInvite");
            } else {
              logger.warn("⚠️ [ProcessInvite] Invite processing returned success=false");
            }
          } catch (err) {
            logger.error("❌ [ProcessInvite] Failed to process invite:", err);
          }
        } else {
        }
      } else {
      }
    };

    processInvite();
  }, [user?.id]);

  return (
    <>
      <InviteSuccessModal
        event={inviteResult?.event}
        prize={inviteResult?.prize}
        onClose={() => setShowInviteModal(false)}
        show={showInviteModal && inviteResult}
      />
    </>
  );
};

export default ProcessInvite;
